import { render, staticRenderFns } from "./declareAnswer.vue?vue&type=template&id=b1209896&"
import script from "./declareAnswer.vue?vue&type=script&lang=js&"
export * from "./declareAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports